export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_USERS_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_USERS_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_USERS_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_USER_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_USER_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_USER_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_USER_SUCCESS",
}
export interface IHabitUser {
  id: string;
  password: string;
  last_login: string | null;
  is_superuser: boolean;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  is_active: boolean;
  date_joined: string;
  username: string;
  public_id: string;
  email: string;
  type: string;
  name: string;
  is_guest: boolean;
  ip: string | null;
  tokens: number;
  activation_key: string;
  otp: string;
  terms_accepted: boolean;
  tutorial_progress: Record<string, unknown>;
  progress_updated_at: string | null;
  groups: any[];
  user_permissions: any[];
  coaches: any[];
}

interface NormalizedEntities {
  [key: string]: IHabitUser;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
}
